import React, { useEffect } from 'react'
import { User } from 'lucide-react'
import { useAvatar } from '../avatar/avatar.context'

const Voice = () => {
  const { chat } = useAvatar()
  const isAvatar = (message) => message.type === 'avatar'

  useEffect(() => {
    console.log('Chat Container Scrolled')

    document.getElementById('chat-container').scrollTo({
      top: document.getElementById('chat-container').scrollHeight,
      behavior: 'smooth',
    })
  }, [chat])

  return (
    <>
      <div className='relative h-full min-h-[360px] flex'>
        {chat.length ? (
          <div
            className='w-full h-16 absolute -top-0 left-0 z-10'
            style={{
              backgroundColor: 'rgb(35,137,251)',
              background:
                'linear-gradient(0deg, rgba(23,29,57,0) 0%, rgba(1,7,43,0.84) 100%)',
            }}
          ></div>
        ) : (
          ''
        )}
        <div
          id='chat-container'
          className='max-h-[460px] flex flex-col px-4 pr-8 pt-8 overflow-auto custom-scrollbar relative'
          style={{ scrollSnapType: 'y mandatory', scrollSnapAlign: 'end' }}
        >
          {chat.map((element, idx) => (
            <div
              key={idx}
              className={`mt-4 ${
                idx == 0 ? 'mt-auto' : ''
              } relative max-w-[75%] ${
                isAvatar(element) ? 'mr-auto' : 'ml-auto'
              }`}
            >
              {/* Profile Icon */}
              <div
                className={`w-8 h-8 absolute -top-4 ${
                  isAvatar(element)
                    ? '-left-4  border-2 border-blue-400 bg-blue-100'
                    : '-right-4 bg-gray-200'
                } flex items-center justify-center rounded-full`}
              >
                {isAvatar(element) ? (
                  <div className='w-6 h-6 p-0.5'>
                    <img
                      src='/images/chat-logo.png'
                      alt='chat-logo'
                      className='w-full object-cover'
                    />
                  </div>
                ) : (
                  <User size={20} />
                )}
              </div>

              {/* Chat Bubble */}
              <div
                className={`px-4 py-2 rounded-2xl shadow ${
                  isAvatar(element) ? ' bg-blue-100' : 'bg-gray-200'
                }`}
              >
                <p className='text-gray-700 text-md font-medium'>
                  {element.message}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default Voice
